import React from "react";
import { Toast } from "radix-ui";
import "../ui.css";
import { useDataUiTheme } from "../utility/getDataUiTheme";
export var RadixToastProvider = function (_a) {
    var children = _a.children;
    return (React.createElement(Toast.Provider, { swipeDirection: "right" },
        children,
        React.createElement(Toast.Viewport, { className: "radix-toast-viewport" })));
};
export var RadixToast = function (_a) {
    var open = _a.open, message = _a.message, _b = _a.variant, variant = _b === void 0 ? "info" : _b, _c = _a.durationMs, durationMs = _c === void 0 ? 3500 : _c, _d = _a.mustAcknowledge, mustAcknowledge = _d === void 0 ? false : _d, actionLabel = _a.actionLabel, onAction = _a.onAction, onOpenChange = _a.onOpenChange;
    var uiTheme = useDataUiTheme();
    var isOpen = open && Boolean(message);
    var toastDuration = mustAcknowledge ? 2147483647 : durationMs;
    return (React.createElement(Toast.Root, { className: "radix-toast radix-toast--".concat(variant), open: isOpen, onOpenChange: onOpenChange, duration: toastDuration, "data-ui-theme": uiTheme },
        React.createElement(Toast.Title, { className: "radix-toast-message" }, message),
        actionLabel && onAction ? (React.createElement(Toast.Action, { asChild: true, altText: actionLabel },
            React.createElement("button", { type: "button", className: "radix-toast-action", onClick: onAction }, actionLabel))) : null,
        React.createElement(Toast.Close, { asChild: true },
            React.createElement("button", { type: "button", className: "radix-toast-close", "aria-label": "Close notification" }, "\u00D7"))));
};
